// extracted by mini-css-extract-plugin
export default {"btnFormula":"PricingPriceCalcSchemaCreatorModal_btnFormula__AD1GF"};